import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';
import styles from './ConfirmationLT.module.css';
import classNames from 'classnames';
import useLoadAtTop from '../../../_ReactHooks/useLoadAtTop';
import useTranslation from '../../../contexts/LanguageTranslation/useTranslation';
import { useHistory } from 'react-router-dom';
import { ContractContext } from '../../../contexts/ContractContext';
import getClientContent, { appleServiceNumbers } from '../../../../components/_BrandingProvider/brandContent';
import ExclamationCircle from '../../../../assets/images/exclamation-circle.svg';
import SBExclamationCircle from '../../../../assets/images/Vendor/SB/exclamation-circle.svg';

let btnPrimary = 'btn-primary';
let mt18 = styles.mt18;
let confirmBold = styles.confirmBold;

const ErrorMessages = () => {
    useLoadAtTop();
    const international = useTranslation('components/Vendor/Apple/IntakeLoss/ErrorMessages');
    const history = useHistory();
    const { translations, country } = international;
    const contractContext = useContext(ContractContext);
    const {
        data: { isChileApple, clientId }
    } = contractContext;
    const [errorImgSrc, setErrorImgSrc] = useState(ExclamationCircle);
    const customerServicePhone = appleServiceNumbers.customerService[country];

    useEffect(() => {
        document.title = `System Error | ${getClientContent(clientId || 'apple')?.variableText?.pageTitle}`;
        history?.location?.state?.isFNOLSystemError && handleFNOLSystemError();
    }, []);

    const getStepByPath = (path) => {
        switch (path) {
            case '/vendor/apple/entitlement':
                return 1;
            case '/vendor/apple/verifyinfo':
                return 2;
            case '/vendor/apple/payment':
                return 3;
            // If not these paths the FNOL system error page should not be reached, API will fail to send email - SEU-29532
            default:
                return null;
        }
    };

    const handleFNOLSystemError = async () => {
        // We save the step and send the abandon email on system failure
        const path = history?.location?.state?.path;
        const step = getStepByPath(path);
        const claim = history?.location?.state?.claim;
        const entitlementDetails = history?.location?.state?.entitlementDetails;
        const partyModel = entitlementDetails?.party;
        const model = { claimModel: claim, partyModel: null };

        fetch(`api/claim/SaveForLater/${claim.claimId}/${step}/${true}/apple`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(model)
        });
    };

    useEffect(() => {
        if (isChileApple) {
            setErrorImgSrc(SBExclamationCircle);
        } else {
            setErrorImgSrc(ExclamationCircle);
        }
    }, [isChileApple]);

    // block component rendering until translation service call resolves translations
    if (!international.isTranslationResolved) return null;

    return (
        <Container>
            <section
                id='apiError'
                className={styles.confirmSection}
            >
                <Row>
                    <Col>
                        <img
                            className={styles.errorIcon}
                            alt='System Error'
                            src={errorImgSrc}
                        />
                        <h1 className='h3'>{translations.title || 'Oops, something went wrong on our side.'}</h1>

                        <p className={styles.confirmBold}>
                            {translations.p1 || 'Our system is unable to process your request at this time.'}
                        </p>

                        <p className={styles.confirmBold}>
                            {translations.pleaseCall || 'Please call '}
                            <a
                                href={`tel:${customerServicePhone}`}
                                className={classNames('callLink', confirmBold)}
                            >
                                {customerServicePhone}
                            </a>
                            {translations.orTryLater || ' or try again later.'}
                        </p>
                    </Col>
                </Row>
            </section>
        </Container>
    );
};

export default ErrorMessages;
